export const reduce = (obj, fn, acc) =>
  Object.keys(obj).reduce(function reducer(newAcc, key) {
    return fn(newAcc, obj[key], key)
  }, acc)
